/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationAggregationRequest extends models.UtilizationStatisticsRequest {
    getFixupPrototypeFunction() { return UtilizationAggregationRequest.fixupPrototype; }

    static newInstance(model: Partial<UtilizationAggregationRequest>): UtilizationAggregationRequest {
        let obj = Object.assign(new UtilizationAggregationRequest(), model);
        UtilizationAggregationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationAggregationRequest>): UtilizationAggregationRequest {
        if (!model) return null;
        return UtilizationAggregationRequest.newInstance(<UtilizationAggregationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationAggregationRequest) {
        if (!obj) return;

        models.UtilizationAggregationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationAggregationRequest): boolean {
        if (models.UtilizationStatisticsRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UtilizationAggregationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
        if (this.additional_filters) {
            models.QueryOperator.fixupPrototype(this.additional_filters);
        }
    }

    /**
     * Query expression to filter line items.
     */
    filters: models.QueryOperator;

    /**
     * Additional Query expression to filter line items. Filtering the Disk Usage Stats metrics can be applied here.
     */
    additional_filters: models.QueryOperator;

    /**
     * specify the start date.
     */
    start_date: Date;

    /**
     * specify the end date.
     */
    end_date: Date;

}
